import React, {useState, useContext} from 'react';
import {Text, View, StyleSheet} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

import {I18nContext, getLanguageCode} from 'i18n/context/I18nContext';
import DropdownPicker from 'components/DropdownPicker';

import {
  LANGUAGE_ENGLISH_DESC,
  LANGUAGE_SPANISH_DESC,
  LANGUAGE_ENGLISH_CODE,
  LANGUAGE_SPANISH_CODE,
} from 'i18n/utils';

const LanguageSwitcher = () => {
  const {translate, changeLanguage} = useContext(I18nContext);
  const [selectedLanguage, setSelectedLanguage] = useState(getLanguageCode());

  const languageIconColor = {color: '#3457D5'};

  const updateSelectedLanguage = (languageCode) => {
    setSelectedLanguage(languageCode);
    changeLanguage(languageCode);
  };

  const items = [
    {label: LANGUAGE_ENGLISH_DESC, value: LANGUAGE_ENGLISH_CODE},
    {label: LANGUAGE_SPANISH_DESC, value: LANGUAGE_SPANISH_CODE},
  ];

  return (
    <View style={styles.container}>
      <View style={styles.pickerContainer}>
        <View style={styles.pickerHeader}>
          <Icon
            type="MaterialCommunityIcons"
            style={[styles.icon, languageIconColor]}
            name="closed-caption"
          />
          <Text style={styles.settingsText}>
            {translate('languageSwitcher.chooseLanguage')}
          </Text>
        </View>
        <DropdownPicker
          selectedValue={selectedLanguage}
          onValueChange={(itemValue) => {
            updateSelectedLanguage(itemValue);
          }}
          items={items}
          style={styles.picker}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
  },
  pickerContainer: {
    flexDirection: 'column',
  },
  pickerHeader: {
    flexDirection: 'row',
  },
  picker: {
    marginTop: 8,
  },
  settingsText: {
    fontSize: 18,
    marginTop: 5,
  },
  icon: {
    fontSize: 28,
    margin: 5,
  },
});

export default LanguageSwitcher;
